<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import moment from "moment";

  import type { DistributorVacation } from "@shared/types/Distributor";

  export let vacation: DistributorVacation;
  export let vacationToEdit: DistributorVacation;
  export let showVacationModal: boolean;
  export let showOrEditModal: string;

  const editVacation = () => {
    vacationToEdit = { ...vacation };
    convertToLocalWithTime();
    showOrEditModal = "edit";
    showVacationModal = true;
  };

  const convertToLocalWithTime = () => {
    vacationToEdit.start_time = moment.utc(vacationToEdit.start_time).local();
    if (vacationToEdit.end_time) {
      moment.utc(vacationToEdit.end_time).local();
    }
  };

  const displayLocal = time => {
    return moment.utc(time).local().format("M/D/YY h:mm A");
  };
</script>

<FizzStyles>
  <div class="fizz-card fizz-bordered" data-testid={`vacation_${vacation.id}`}>
    <div class="fizz-inset-square-8 fizz-flex-row fizz-space-between">
      <span class="fizz-text-strong"
        >{displayLocal(vacation.start_time)} - {vacation.end_time
          ? displayLocal(vacation.end_time)
          : "Indefinite"}</span
      >
      <div class="fizz-text-right">
        <button class="fizz-button-primary" on:click={editVacation}>Edit</button>
      </div>
    </div>
    <div class="fizz-text-left fizz-inset-square-8">
      <div>Orders assigned to: {vacation.assigned_sales_rep.name}</div>
      {#if vacation.sales_rep}
        <div>Orders assigned from: {vacation.sales_rep.name}</div>
      {/if}
    </div>
    <div class="fizz-flex-row fizz-inset-square-8 fizz-space-between">
      <div class="fizz-text-left">
        Notifications
        {#if vacation.keep_notifying}
          <span class="fizz-text-positive">ON</span>
        {:else}
          <span class="fizz-text-negative">OFF</span>
        {/if}
      </div>
    </div>
  </div>
</FizzStyles>
